export function formatDate(dateString: string, format: string = 'full'): string {
  const date = new Date(dateString);
  let options: Intl.DateTimeFormatOptions;

  switch (format) {
    case 'condensed':
      // For the condensed format, we'll use a custom implementation
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // getMonth() is 0-indexed
      const year = date.getFullYear().toString().slice(-2);
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${day}/${month}/${year}, ${hours}:${minutes}`;
    default:
      options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      };
  }

  // For non-condensed formats, use Intl.DateTimeFormat
  return new Intl.DateTimeFormat('en-US', options).format(date);
}
